import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_LOGIN } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath"; 
import axios from "axios";
import { toast } from '../../components/toast';
import { sessionService } from "../../services/sessionService";
import { getLocalizedMessage, getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

export const postLogin = createAsyncThunk(
  ACTIONS_LOGIN.post_login,
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.login,
        payload
      );
      
      const message = getLocalizedMessage(response, i18n);
      toast.success(message);
      
      // Set session start time for background refresh monitoring
      sessionService.setSessionStartTime();
      
      return response.data;
      
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      console.error("Login Error:", error);
      throw error;
    }
  }
);
